import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { Row, Col, Spin, Empty, Typography, Table } from 'antd';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
// import * as AntDIcons from '@ant-design/icons';
// import NoticeBoard from '../../components/notice-board/NoticeBoard';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
// import SimpleBarReact from "simplebar-react";
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';

const { Text } = Typography;

var data_main = [];

export function MasteryReportType5(props) {
   const navigate = useNavigate();
   // const location = useLocation();

   const search = window.location.search;
   const query = new URLSearchParams(search);

   const level = query.get('level');
   const subject = query.get('subject');
   const assigned_by = query.get('assigned_by');

   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   const [data, setData] = useState({
      loading: false,
      hasData: false,
   })

   useEffect(() => {
      Utils.verifyJwt();

      // if (user_role.toLowerCase() !== 'admin' && user_role.toLowerCase() !== 'teacher' && user_role.toLowerCase() !== 'co-teacher')
      const allowedRoles = ['super admin', 'admin', 'teacher', 'co-teacher'];
      if (!allowedRoles.includes(user_role.toLowerCase()))
         navigate('/home');

      getMasteryReportData(0, level, subject, assigned_by);
   }, []);

   const report_columns = [
      {
         title: 'Student',
         key: 'student_name',
         dataIndex: 'student_name',
         width: '30%',
      },
      {
         title: 'First Quarter',
         key: 'term_1_score',
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            object.term_1_total_points !== 0
               ?
               <Text>{object.term_1_score}/{object.term_1_total_points}</Text>
               :
               <></>
         ),
         align: 'center',
         width: '15%',
      },
      {
         title: 'Second Quarter',
         key: 'term_2_score',
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            object.term_2_total_points !== 0
               ?
               <Text>{object.term_2_score}/{object.term_2_total_points}</Text>
               :
               <></>
         ),
         align: 'center',
         width: '15%',
      },
      {
         title: 'Third Quarter',
         key: 'term_3_score',
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            object.term_3_total_points !== 0
               ?
               <Text>{object.term_3_score}/{object.term_3_total_points}</Text>
               :
               <></>
         ),
         align: 'center',
         width: '15%',
      },
      {
         title: 'Fourth Quarter',
         key: 'term_4_score',
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            object.term_4_total_points !== 0
               ?
               <Text>{object.term_4_score}/{object.term_4_total_points}</Text>
               :
               <></>
         ),
         align: 'center',
         width: '15%',
      },
   ];

   const getMasteryReportData = (term, level, subject, assigned_by) => {
      setData({
         loading: true,
         hasData: false,
      });

      var url = `${process.env.REACT_APP_API_MASTERY_ASSESSMENT}/getmasteryreportdata5?term=${term}&level=${level}&subject=${subject}&assigned_by=${assigned_by}`;

      axios.get(url).then((response) => {
         console.log(response);

         if (response.data) {
            data_main = response.data;
            setData({
               loading: false,
               hasData: data_main.length > 0 ? true : false,
            });
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   function GenerateReport() {
      var retVal = (
         <>
            <div style={{ width: '100%', textAlign: 'center' }}>
               <h5><b>Class Summary Report - Summative Assessment</b></h5>
            </div>
            <Row style={{ rowGap: "0px" }}>
               <Col span={24} style={{ textAlign: "left" }}>
                  <span>Teacher: <b>{data_main[0].teacher}</b></span>
               </Col>
            </Row>
            <Row style={{ rowGap: "0px" }}>
               <Col span={24} style={{ textAlign: "left" }}>
                  <span>Subject: <b>{subject === '0' ? "All" : data_main[0].subject}</b></span>
               </Col>
            </Row>
            <Row style={{ rowGap: "0px", paddingBottom: "20px" }}>
               <Col span={24} style={{ textAlign: "left" }}>
                  <span>Grade: <b>{level === '0' ? "All" : data_main[0].grade_level}</b></span>
               </Col>
            </Row>
            <Row style={{ paddingBottom: '2rem' }}>
               <Col span={24}>
                  <Table
                     size='small'
                     columns={report_columns}
                     dataSource={data_main}
                     pagination={false}
                     rowKey={'uid'}
                     // style={{ minWidth: "1000px" }}
                     scroll={{
                        x: '1000px'
                     }}
                  />
               </Col>
            </Row>
         </>
      );

      return retVal;
   }

   return (
      <>
         <div className="dashboard-area-all">
            <div className="dashboard-item">
               <div className="dashboard-item-inner">
                  {/* <ul>
                     <li><a href="#" onClick={() => navigate('/home')}>Home</a></li>
                     <li><span>/</span></li>
                     <li className="active">Brainee LMS</li>
                     <li><span>/</span></li>
                     <li><a href="#" onClick={() => navigate('/masteryassessmentreport')}>Mastery Assessment Report</a></li>
                     <li><span>/</span></li>
                     <li className="active">Report Type 3</li>
                  </ul> */}
                  <ResponsiveBreadcrumb
                     style={{ paddingBottom: '15px' }}
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'lms', node: 'Brainee LMS' },
                        { key: 'mastery-assessment-report', node: <a href="#" onClick={() => navigate('/masteryassessmentreport')}>Mastery Assessment Report</a> },
                        { key: 'report-type-5', node: 'Report Type 5' },
                     ]}
                  />
               </div>

               {/* <SimpleBarReact style={{ height: "calc(100vh - 55px)" }}> */}
               {data.loading === false
                  ?
                  <>
                     {
                        data.hasData
                           ?
                           // <div className='section_to_print' style={{ width: "calc(100% - 6px)" }}>
                           <div className='section_to_print'>
                              {GenerateReport()}
                           </div>
                           :
                           <div className='temp-answer-sheet-content2'>
                              <Empty description="No data available for report" image="../images/brainee_mascot.png" />
                           </div>
                     }
                  </>
                  :
                  <>
                     <div className='mastery_assessment_list'>
                        <Spin size='large' tip="Loading, please wait..." />
                     </div>
                  </>
               }
               {/* </SimpleBarReact> */}
            </div>
         </div>

         {/* <div className="notice-area">
            <div className="notice-item">
               <img src="../images/brainee_ma.png" width="100%" style={{ padding: "5px", maxWidth: '600px' }}></img>
               <NoticeBoard />
            </div>
         </div> */}
      </>
   );
}

